export default __webpack_public_path__ + "static/media/convert-reward-to-ecredit-step1.629a4fb7.png";